import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { tokenStorage } from 'utils/storage';

const isLoggedIn = !!tokenStorage.get();

const userSlice = createSlice({
  name: 'user',
  initialState: {
    isLoggedIn
  },
  reducers: {
    setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.isLoggedIn = action.payload;
    }
  }
});

export const { setIsLoggedIn } = userSlice.actions;
export default userSlice.reducer;
